module.exports = __webpack_public_path__ + "static/media/bsgc_logo.30dc22cd.svg";